import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { api } from './api';

interface User { id: string; email: string; role: string; displayName: string; provider?: string; totpEnabled?: boolean }
interface Ctx { user: User | null; loading: boolean; refresh: () => Promise<void>; logout: () => Promise<void>; }

const AuthCtx = createContext<Ctx>({ user: null, loading: true, refresh: async () => {}, logout: async () => {} });

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    try { setUser(await api.get('/auth/me')); }
    catch { setUser(null); }
    finally { setLoading(false); }
  }
  async function logout() {
    await api.post('/auth/logout');
    setUser(null);
  }
  useEffect(() => { refresh(); }, []);
  return <AuthCtx.Provider value={{ user, loading, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export function useAuth() { return useContext(AuthCtx); }
